export const isDevelopment = () => process.env.NODE_ENV === 'development'
export const isTest = () => process.env.NODE_ENV === 'test'
export const isDevOrTest = () => isDevelopment() || isTest()
